import React from "react";
import Modal from "react-responsive-modal";
import LoadMask from "Utils/LoadMask/LoadMask";
import { formatDisplayNumber } from "../../../../../../../../../../utility/utils";
import { ReprocesoTable } from "./ReprocesoTable";

export const ModalReproceso = ({ cargasFormHook }) => {
    const reprocesoHook = cargasFormHook.reproceso;
    const { esModoPacas, totales } = reprocesoHook;

    return (
        <Modal
            open={reprocesoHook.modalAbierto}
            onClose={reprocesoHook.CerrarModal}
            closeOnOverlayClick={false}
            focusTrapped={false}
        >
            <LoadMask
                loading={reprocesoHook.cargando || cargasFormHook.cargando}
                blur
            >
                <h4 className="text-center mb-4">
                    {esModoPacas
                        ? "Agregar pacas de reproceso"
                        : "Agregar sobrante de reproceso"}
                </h4>

                <ReprocesoTable reprocesoHook={reprocesoHook} />

                <div className="text-center mt-3">
                    <span
                        className={
                            totales.kg > 0 ? "text-success" : "text-muted"
                        }
                        style={{ fontWeight: 600 }}
                    >
                        Total:{" "}
                        {esModoPacas
                            ? `${formatDisplayNumber(totales.pacas)} pacas = `
                            : ""}
                        {formatDisplayNumber(totales.kg, 2)} kg
                    </span>
                </div>

                <div className="d-flex flex-wrap justify-content-center mt-4 mb-2 gap-1rem">
                    <button
                        className="btn btn-outline-dark"
                        onClick={reprocesoHook.CerrarModal}
                    >
                        Regresar
                    </button>

                    <button
                        className="btn btn-primary"
                        onClick={cargasFormHook.AgregarCargaReproceso}
                        disabled={!reprocesoHook.haySeleccion}
                    >
                        Agregar
                    </button>
                </div>
            </LoadMask>
        </Modal>
    );
};
